// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseVoid } from '../../types';

/**
 * 初始化飞书组织架构
 *
 * @export
 * @tags feishu-dep-controller
 * @link [GET] /feishuDeps/init
 */
export function getFeishuDepsInit(): Promise<BaseResponseVoid>;
export function getFeishuDepsInit(options: ApiOptions<never, never>): Promise<BaseResponseVoid>;
export function getFeishuDepsInit(options?: ApiOptions<never, never>): Promise<BaseResponseVoid> {
    return request<never, never, never>('/feishuDeps/init', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getFeishuDepsInit',
    });
}

export const meta = [{ tags: ['feishu-dep-controller'], path: '/feishuDeps/init', method: 'get' }];
